import { useContext } from 'react'
import UserContext from '../../UserContext'
import IdentifierWithCopy from './IdentifierWithCopy'

type SimpleModalContentProps = {
    mainTitle: string
    subTitle: string
    identifier?: string | number
    message: React.ReactNode
}

export const SimpleModalContent: React.FC<SimpleModalContentProps> = ({ mainTitle, subTitle, identifier, message }) => {
    const userContext = useContext(UserContext)
    
    return (
        <>
            <div className="simple-header-bar">
                {/*<i className="fas fa-expand-alt" onClick={() => ExpandContractSimpleModal()}></i>*/}
                <img className="logo forPrintOnly" src="/assets/images/heart.svg" alt="Caresource" width="100%" height="100%" />
                <h1 className="forPrintOnly">Provider Sourcing</h1>
                <span className="user-info forPrintOnly"><span className="name forPrintOnly">{userContext.user.name}</span></span>
                <h3>{mainTitle} / <span className="emphasis">{subTitle}</span>{IdentifierWithCopy({ identifier })}</h3>
            </div>
            <div className="simple-message">
                {message}
            </div>
        </>
    )
}

type SimpleModalButtonProps = {
    onClose?: () => void;
}

export const SimpleModalButton: React.FC<SimpleModalButtonProps> = ({ onClose }) => {
    
    return (
        <>
           <div className='simple-modal-button-section'>
               <button className='button close-simple-modal' onClick={onClose}>Close</button>
           </div>
        </>
    )
}